const hiddenClass = "selling_plan_theme_integration--hidden";


// function roundedToUp(value_input) {
//     let integerPart = Math.floor(value_input);
//     let decimalPart = value_input - integerPart;
//     console.log("value_input", value_input)
//     if (decimalPart > 0.60) {
//         return Math.ceil(value_input);
//     } else if (decimalPart >= 0.40 && decimalPart <= 0.60) {
//         return integerPart + 0.50; 
//     } else {
//         return integerPart;
//     }
// }

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.enablePerformanceObserver();
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();

    this.variantsData = JSON.parse(
      document.querySelector("[data-selling-plans]").innerHTML
    );

    document.addEventListener(
      "SubscriptionWidget:SellingPlanSelected",
      function (event) {
        this.updateInputLabels(event.detail.data.sellingPlanId);
        this.updateOtherVariantsSellingPlanSelectors(
          event.detail.data.sellingPlanId
        );
        this.showFeaturesList();
      }.bind(this)
    );

    document.addEventListener(
      "SubscriptionWidget:SellingPlanRemoved",
      function (event) {
        this.updateInputLabels(null);
        this.updateOtherVariantsSellingPlanSelectors(null);
        this.hideFeaturesList();
      }.bind(this)
    );

    document.addEventListener(
      "Subscription:OptionValueChange",
      function (event) {
        this.selectedVariant = this.variantsData.find(
          (variant) => variant.public_title == event.detail.data.optionName
        );
      }.bind(this)
    );
  }

  updateOtherVariantsSellingPlanSelectors(sellingPlanId) {
    document
      .querySelectorAll(".selling_plan_theme_integration--hidden")
      .forEach((itm) => {
        if (sellingPlanId) {
          itm.querySelector(
            'input[data-radio-type="selling_plan"]'
          ).checked = true;
          itm.querySelector(
            'input[data-radio-type="one_time_purchase"]'
          ).checked = false;
        } else {
          itm.querySelector(
            'input[data-radio-type="one_time_purchase"]'
          ).checked = true;
          itm.querySelector(
            'input[data-radio-type="selling_plan"]'
          ).checked = false;
        }
      });
  }

  formatMoney(cents, format = window.moneyFormat) {
    typeof cents == "string" && (cents = cents.replace(".", ""));
    var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (
        ((thousands = thousands || ","),
          (decimal = decimal || "."),
          isNaN(number) || number === null)
      )
        return 0;
      number = (number / 100).toFixed(precision);

      var parts = number.split("."),
        dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        centsAmount = parts[1] ? decimal + parts[1] : "";

      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    // let priceRound = roundedToUp(value);

    return formatString.replace(placeholderRegex, value);
  }

  hideFeaturesList() {
    this.shopifySection
      .querySelector(".variant-selects__features-list")
      .classList.add("hidden");
    // this.shopifySection
    //   .querySelector("[data-subscription-frequencies]")
    //   .classList.add("hidden");
    document
      .querySelectorAll("[data-subscription-frequencies]")
      .forEach((itm) => itm.classList.add("hidden"));
  }

  showFeaturesList() {
    this.shopifySection
      .querySelector(".variant-selects__features-list")
      .classList.remove("hidden");
    // this.shopifySection
    //   .querySelector("[data-subscription-frequencies]")
    //   .classList.remove("hidden");
    document
      .querySelectorAll("[data-subscription-frequencies]")
      .forEach((itm) => itm.classList.remove("hidden"));
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute("data-section-id");
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  /*
    We are careful to target the correct form, as there are instances when we encounter an installment form that we specifically aim to avoid interacting with.
  */
  get variantIdInput() {
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0].querySelector(`input[name="id"]`) ||
      this.addToCartForms[0].querySelector(`select[name="id"]`)
    );
  }

  get priceElement() {
    return this.shopifySection.querySelector(".price");
  }

  get comparedAtPrice() {
    return this.shopifySection.querySelector(".price__sale");
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`
    );
  }

  get isVariantAvailable() {
    return this.selectedPurchaseOption.getAttributeNames().includes("disabled");
  }

  get sellingPlanInput() {
    return this.shopifySection.querySelector(".selected-selling-plan-id");
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }

  /*
    To enable the addition of a selling plan to a cart, it's necessary to include an input with the name "selling_plan", which will carry the selling ID as its value. When a buyer clicks on 'add to cart', the appropriate selling plan ID is added to their cart.
  */
  appendSellingPlanInputs() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
    });
  }

  /*
    Each product variant comes with a selling plan selection box that the buyer can interact with.
    When a buyer chooses a different variant, we ensure that only the relevant selling plan selection box is displayed.
    This guarantees that only the selling plan associated with the selected variant is shown.
  */
  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  /*
    The functions listenToVariantChange() and listenToAddToCartForms() are implemented to track when a product variant is altered or when the product form is updated.
    The identification of the variant is crucial as it dictates which selling plan box should be displayed.
  */
  listenToVariantChange() {
    this.listenToAddToCartForms();
    if (this.variantIdInput.tagName === "INPUT") {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });

      variantIdObserver.observe(this.variantIdInput, {
        attributes: true,
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener("change", () => {
        // this.handleVariantChange();
      });
    });
  }

  get regularPriceElement() {
    return this.shopifySection.querySelector(".price__regular");
  }

  get salePriceElement() {
    return this.shopifySection.querySelector(".price__sale");
  }

  get salePriceValue() {
    return this.salePriceElement.querySelector(".price-item--sale");
  }

  get regularPriceValue() {
    return this.salePriceElement.querySelector(".price-item--regular");
  }

  get sellingPlanAllocationPrice() {
    return document.getElementById(
      `${this.selectedPurchaseOption.dataset.sellingPlanGroupId}_allocation_price`
    );
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption.dataset.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption.dataset.variantCompareAtPrice;
  }

  get price() {
    return this.sellingPlanAllocationPrices.price ?? null;
  }

  /*
    We aim to ascertain whether a compared price exists, which would indicate that the currently selected input has a discount applied to it.
    If a discount is detected, the discounted price is displayed; otherwise, the regular price is shown.
  */

  updateInputLabels(sellingPlanId) {
    // console.log("sellingPlanId", sellingPlanId)
    this.variantsData.forEach((variant) => {
      const label = document.querySelector(
        `[data-corresponding-variant="${variant.id}"]`
      );

      if (!label) return;

      let price = variant.price;
      let comparePrice = variant.compare_at_price;
      let savePercent = comparePrice > 0 ? ((comparePrice - price) / comparePrice) * 100 : 0;

      if (sellingPlanId) {
        const sellingPlan = variant.selling_plan_allocations.find(
          (plan) => plan.selling_plan_id == sellingPlanId
        );
        if (sellingPlan && price) {
          price = sellingPlan.price;
        }
        // comparePrice = sellingPlan.compare_at_price;

        savePercent = variant.compare_at_price > 0 ?
          ((variant.compare_at_price - price) / variant.compare_at_price) * 100 : 0;
      }

      const selectors = {
        packPrice: `[data-pack-price]`,
        comparePrice: `[data-compare-price]`,
        salePrice: `[data-sale-price]`,
      };

      label
        .querySelectorAll(selectors.comparePrice)
        .forEach((itm) => (itm.innerHTML = this.formatMoney(comparePrice)));

      label.querySelectorAll(selectors.salePrice).forEach((itm) => {
        itm.innerHTML = this.formatMoney(price);
      });

      label.querySelectorAll(selectors.packPrice).forEach((itm) => {
        let ad = Math.floor(price / variant.public_title.split(" ")[0]);
        //console.log("price", price, variant.public_title.split(" ")[0], ad)
        itm.innerHTML = this.formatMoney(
          ad
        );

      });

      const saveLabel = label.querySelector(".variant-picker-input-label__save-label");
      if (saveLabel) {
        saveLabel.innerHTML = "Save " + savePercent.toFixed(0) + "%";
      }
    });
  }

  updatePrice() {
    if (
      !this.selectedPurchaseOptionComparedAtPrice ||
      this.selectedPurchaseOptionComparedAtPrice ===
      this.selectedPurchaseOptionPrice
    ) {
      // this.showRegularPrice();
      // this.hideSalePrice();
      // this.priceElement.classList.remove("price--on-sale");
    } else {
      // this.showSalePrice();
      // this.hideRegularPrice();
      // this.priceElement.classList.add("price--on-sale");
    }
  }

  hideSalePrice() {
    this.salePriceElement.style.display = "none";
  }

  hideRegularPrice() {
    this.regularPriceElement.style.display = "none";
  }

  showRegularPrice() {
    this.regularPriceElement.style.display = "block";
    this.shopifySection.querySelector(".price__sale").style.display = "none";
  }

  showSalePrice() {
    // this.salePriceElement.style.display = "block";
    // this.regularPriceValue.innerHTML =
    //   this.selectedPurchaseOptionComparedAtPrice;
    // this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll(".selected-selling-plan-id");
  }

  updateSellingPlanInputsValues() {
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      // sellingPlanInput.value = this.sellingPlanInputValue;
    });
  }


  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? null;
  }

  get selectedPurchaseOption() {
    // console.log("selectedPurchaseOption", this.visibleSellingPlanForm);
    return this.visibleSellingPlanForm?.querySelector(
      '.selling-plan-frquency-wrapper input[type="radio"]:checked'
    );
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();

    const sellingPlanId = selectedPurchaseOption.dataset.sellingPlanId;

    // console.log("selectedPurchaseOption", selectedPurchaseOption);
    // console.log("selling_plan_id", sellingPlanId);
    // setTimeout(() => {
    //   updatePrices();
    // }, 1);

    // await  updatePrices();



    if (sellingPlanId) {
      // console.log("dispatching event SubscriptionWidget:SellingPlanSelected");

      const sellingPlanId = selectedPurchaseOption.dataset.sellingPlanId;
      document
        .querySelectorAll(`[data-selling-plan-id="${sellingPlanId}"]`)
        .forEach((itm) => (itm.checked = true));

      this.sellingPlanInputs.forEach((sellingPlanInput) => {
        sellingPlanInput.value = sellingPlanId;
      });

      document.dispatchEvent(
        new CustomEvent("SubscriptionWidget:SellingPlanSelected", {
          bubbles: true,
          detail: {
            data: {
              sellingPlanId: sellingPlanId,
            },
          },
        })
      );
      return;
    }

    // console.log("dispatching event SubscriptionWidget:SellingPlanRemoved");

    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = "";
    });

    document.dispatchEvent(
      new CustomEvent("SubscriptionWidget:SellingPlanRemoved", {
        bubbles: true,
      })
    );
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"]')
      .forEach((radio) => {
        radio.addEventListener("change", async (event) => {
          this.handleRadioButtonChange(event.target);
          await updatePrices();
        });
      });
  }

  enablePerformanceObserver() {
    const performanceObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== "fetch") return;

        const url = new URL(entry.name);
        /*
          When a buyer selects a product variant, a fetch request is initiated.
          Upon completion of this fetch request, we update the price to reflect the correct value.
        */
        if (url.search.includes("variant") || url.search.includes("variants")) {
          this.updatePrice();
        }
      });
    });

    performanceObserver.observe({ entryTypes: ["resource"] });
  }

}

document
  .querySelectorAll(".selling_plan_app_container")
  .forEach((sellingPlansWidgetContainer) => {
    new SellingPlansWidget(sellingPlansWidgetContainer);
  });




// code by coder
const updatePrices = async () => {

  let checkedRadio = document.querySelector('.cus-variant-item input[type="radio"]:checked');

  if (checkedRadio) {
    let closestItem = checkedRadio.closest('.cus-variant-item');
    // console.log("closestItem", closestItem)
    let comparePrice = closestItem.querySelector('label .variant-picker-input-label__compare-price')?.textContent || '';
    let price = closestItem.querySelector('label .variant-picker-input-label__price')?.textContent || '';
    let onePackPrice = closestItem.querySelector('label .one-pack-price')?.textContent || '';

    let newPrice = document.querySelector('.sale-price');
    let newSingleItemComparePrice = document.querySelector('.new-compare-price');
    let newSinglePackPrice = document.querySelector('.single-item-price .first_later_price');

    if (price && newPrice) {
      newPrice.textContent = price;
    }
    if (comparePrice && newSingleItemComparePrice) {
      let cleanedComparePrice = comparePrice.replace(".00", "").replace(",00", "");
      newSingleItemComparePrice.textContent = cleanedComparePrice;
    }
    if (onePackPrice && newSinglePackPrice) {
      newSinglePackPrice.textContent = onePackPrice;
    }
  } else {
    console.log("No radio button is checked.");
  }
};


document.querySelectorAll('.cus-variant-item input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', async () => {
    // setTimeout(() => {
    //   updatePrices();
    // }, 50);

    await updatePrices();
  });
});


document.addEventListener('DOMContentLoaded', async () => {
  // setTimeout(() => {
  //   updatePrices();
  // }, 50);
  await updatePrices();
});

// document.addEventListener('DOMContentLoaded', async () => {
//   const selectedRadio = document.querySelector(
//     '.selling_plan_app_container input[type="radio"][data-radio-type="selling_plan"]:checked'
//   );

//   if (selectedRadio) {
//     selectedRadio.dispatchEvent(new Event('change', { bubbles: true }));
//   } else {
//     const oneTimeRadio = document.querySelector(
//       '.selling_plan_app_container input[type="radio"][data-radio-type="one_time_purchase"]:checked'
//     );
//     if (oneTimeRadio) {
//       oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     }
//   }
// });

// endcoder

const planList = document.querySelectorAll('.selling-plan__radios-wrapper .selling-plan__radio-wrapper');

const subscribeInfo = document.querySelectorAll('.subscribe-info');
const oneTimeInfo = document.querySelectorAll('.ontime-info');
const variantItems = document.querySelectorAll('.cus-variant-item');
const oneTimeBadge = document.querySelector('.product__custom-badge-wrapper .custom__onetime-badge');
const subscribeBadge = document.querySelector('.product__custom-badge-wrapper .custom__subscribe-badge');
let salePrice = document.querySelector('.sale-price:not(.subscription-sale-price)');
let subscriptionPrice = document.querySelector('.subscription-sale-price');
let pricePerPack = document.querySelector('.single-item-price:not(.subscription-price-per-pack)');
let subscriptionPricePerPack = document.querySelector('.subscription-price-per-pack');


const toggleVariants = (isSubscribe) => {
  if (variantItems.length === 0) return;

  const isBundle = document.body.classList.contains('template-bundle-product');
  const indexToKeep = isBundle ? 0 : 1;
  const targetItem = variantItems[indexToKeep] || variantItems[0];
  const targetRadio = targetItem.querySelector('input[type="radio"]');

  if (isSubscribe) {
    variantItems.forEach((item, index) => {
      if (index === indexToKeep) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
        const radio = item.querySelector('input[type="radio"]');
        if (radio && radio.checked && targetRadio) {
          targetRadio.checked = true;
          targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    if (subscribeBadge) {
      const isEmpty = subscribeBadge.textContent.trim() === '';
      subscribeBadge.style.display = 'inline';
      oneTimeBadge.style.display = 'none';
      if (isEmpty) subscribeBadge.style.display = 'none';
    }
    if (subscriptionPrice) {
      subscriptionPrice.classList.remove('hidden');
      salePrice.style.display = "none";
    }
    if (subscriptionPricePerPack) {
      subscriptionPricePerPack.classList.remove('hidden');
      pricePerPack.style.display = "none";
    }
  } else {
    variantItems.forEach((item) => {
      item.style.display = 'block';
    });

    if (subscribeBadge) {
      subscribeBadge.style.display = 'none';
      oneTimeBadge.style.display = 'inline';
    }
    if (subscriptionPrice) {
      subscriptionPrice.classList.add('hidden');
      salePrice.style.display = "inline-block";
    }
    if (subscriptionPricePerPack) {
      subscriptionPricePerPack.classList.add('hidden');
      pricePerPack.style.display = "inline-block";
    }
  }

  // Toggle subscription design class
  variantItems.forEach(item => {
    if (isSubscribe) {
      item.classList.add('show-subscription-design');
    } else {
      item.classList.remove('show-subscription-design');
    }
  });

  // Toggle global headings
  if (isSubscribe) {
    subscribeInfo.forEach((item) => item.style.display = 'block');
    oneTimeInfo.forEach((item) => item.style.display = 'none');
  } else {
    subscribeInfo.forEach((item) => item.style.display = 'none');
    oneTimeInfo.forEach((item) => item.style.display = 'block');
  }
};


const toggleImageWithTextVisibility = (isSubscribe) => {
  const imageWithTextBlocks = document.querySelectorAll('.image-with-text');

  imageWithTextBlocks.forEach(block => {
    const subscribeInfoText = block.querySelector('.subscribe-info-text');
    const onetimeInfoText = block.querySelector('.ontime-info-text');

    // Reset displays first to ensure clean state
    if (subscribeInfoText) subscribeInfoText.style.display = 'none';
    if (onetimeInfoText) onetimeInfoText.style.display = 'none';
    block.style.display = 'none'; // Hide parent by default

    if (isSubscribe) {
      if (subscribeInfoText && subscribeInfoText.innerText.trim().length > 0) {
        subscribeInfoText.style.display = 'block';
        block.style.display = 'flex'; // Show parent if content exists
      }
    } else {
      if (onetimeInfoText && onetimeInfoText.innerText.trim().length > 0) {
        onetimeInfoText.style.display = 'block';
        block.style.display = 'flex'; // Show parent if content exists
      }
    }
  });
};

planList.forEach((plan) => {
  plan.addEventListener('click', async () => {
    planList.forEach((otherPlan) => {
      otherPlan.classList.remove('selectedplan');
    });
    plan.classList.add('selectedplan');

    const isSubscribe = plan.getAttribute('for') === 'subscribe';
    toggleVariants(isSubscribe);
    toggleImageWithTextVisibility(isSubscribe);

  });
});

document.addEventListener('DOMContentLoaded', () => {
  const activePlan = document.querySelector('.selling-plan__radio-wrapper.selectedplan');
  if (activePlan) {
    const isSubscribe = activePlan.getAttribute('for') === 'subscribe';
    toggleVariants(isSubscribe);
    toggleImageWithTextVisibility(isSubscribe);
  }
});




// endcoder

